import { Chip, type SvgComponentType } from "@newsela/angelou";
import { objectTypes } from "@newsela/snitch";

import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";
import { IContentValues } from "../../types/IContentValues";
import {
  contentTypeSvgMap,
  excludedTypes,
} from "./ContentTypeFilterChips.constants";
import { getContentTypeChipCss } from "./ContentTypeFilterChips.styles";

interface IContentTypeFilterChips {
  activeChips: string[];
  contentTypeValues: IContentValues[];
}

export const ContentTypeFilterChips = ({
  activeChips,
  contentTypeValues,
}: IContentTypeFilterChips) => {
  const {
    handlers: { getSearchParamValues },
  } = useSearchPageContext();

  const isSelectAllChipActive = activeChips.length === 0;

  return (
    <>
      <Chip
        __cssFor={getContentTypeChipCss(isSelectAllChipActive, true)}
        key="select-all-chip"
        dataProps={{
          "data-qa-selector": "select-all-content-types-filter",
          "data-testid": "select-all-content-types-filter",
          "data-tracker-model": objectTypes.content,
        }}
        active={
          !getSearchParamValues(AgathaSchemaParamsEnum.content_types).length
        }
        text="All"
        value="all"
      />
      {contentTypeValues.map((contentType, index) => {
        if (excludedTypes.includes(contentType.value)) return null;

        const isContentTypeChipActive = activeChips.includes(contentType.value);

        return (
          <Chip
            __cssFor={getContentTypeChipCss(isContentTypeChipActive)}
            key={index}
            dataProps={{
              "data-qa-selector": `select-${contentType.value}-search-filter`,
              "data-testid": `select-${contentType.value}-search-filter`,
              "data-tracker-model": objectTypes.content,
            }}
            active={isContentTypeChipActive}
            text={contentType.label}
            SvgComponent={
              contentTypeSvgMap[contentType.value] as SvgComponentType
            }
            value={contentType.value}
          />
        );
      })}
    </>
  );
};
